/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_DoneInputs */

const en_settings_apikeys_done = /** @type {(inputs: Settings_Apikeys_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

const zh_settings_apikeys_done = /** @type {(inputs: Settings_Apikeys_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成`)
};

/**
* | output |
* | --- |
* | "Done" |
*
* @param {Settings_Apikeys_DoneInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_done = /** @type {((inputs?: Settings_Apikeys_DoneInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_DoneInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_apikeys_done(inputs)
	return zh_settings_apikeys_done(inputs)
});
export { settings_apikeys_done as "settings.apikeys.done" }